import { WorkerRequirementMappingLevel } from "@clipboard-health/contract-worker-app-bff";
import { uniq } from "lodash";

import { type WorkerRequirement } from "../api/types";

export function getRequirementWorkplacesIds(requirement: WorkerRequirement) {
  return (
    requirement.requirementMappings?.reduce<string[]>((result, mapping) => {
      if (mapping.attributes.level !== WorkerRequirementMappingLevel.HCF) {
        return result;
      }

      return uniq([...result, ...mapping.attributes.requiredBy]);
    }, []) ?? []
  );
}
